/** Une nombres de clase, descartando los valores falsy. */
export function cx(...names: Array<string | false | null | undefined>): string {
  return names.filter(Boolean).join(' ')
}
